document.addEventListener("DOMContentLoaded", () => {
  $('.mm-new-arrivals .product-container').slick({
    infinite: true,
    draggable: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});